import SliderPopover from './SliderPopover';

export default SliderPopover;
